export const defaultKeys = {
    transcript: '_defaultTranscript',
    imageCaption: '_defaultImageCaption',
    soundCaption: '_defaultSoundCaption',
}
